export enum FORM_CHOICE_CHECKBOX_TYPES {
  PLACEHOLDER = 'PLACEHOLDER'
}

export const FORM_CHOICE_CHECKBOX_COMPONENT_TYPES = {
  PLACEHOLDER: {
    title: `Placeholder`,
    options: [
      { option: 'option 1', value: 'option1' },
      { option: 'option 2', value: 'option2' },
      { option: 'option 3', value: 'option3' }
    ],
    registerAs: 'PLACEHOLDER'
  }
} as const;
